'use es6';

export const APP = 'pricing-pages';
export const SCREENS = {
  PRODUCTS_PLANS: 'products-plans',
  CREATE_BUNDLE: 'create-bundle',
  GROWTH_SUITE: 'growth-suite',
  SUITE: 'suite',
  ERROR: 'error',
  CONTACT_CONFIRMATION: 'contact-confirmation',
  SUITE_CONTACT_CONFIRMATION: 'suite-contact-confirmation',
  MC_CONTACT_CONFIRMATION: 'mc-contact-confirmation',
  CONTACT_SALES: 'contact-sales',
  LEGACY_INTERSTITIAL: 'legacy-interstitial'
};
export const SUBSCREENS = {
  MARKETING_HUB: 'marketing-hub',
  SALES_HUB: 'sales-hub',
  SERVICE_HUB: 'service-hub',
  CMS: 'cms',
  CMS_HUB: 'cms-hub',
  FREE_TOOLS_CRM: 'free-tools-crm',
  OPERATIONS_HUB: 'operations-hub'
};
export const MERCH_CARD = 'merch-card';
export const CALCULATOR = 'calculator';
export const SUITE_CARD = 'suite-card';
export const FREE_CARD = 'free-card';
export const SUITE_CALCULATOR = 'suite-calculator';
export const CMS_CARD = 'cms-card';
export const MIGRATE_YOUR_SITE = 'migrate-your-site';
export const MC_SIDEGRADE_MODAL = 'mc-sidegrade-modal';
export const CREATE_A_BUNDLE = 'create-a-bundle';
export const BUNDLE_CARD = 'bundle-card';
export const MON491_FEATURE_MODAL = 'feature-modal';
export const PAID_VS_FREE_USERS_MODAL = 'paid-vs-free-users-modal';
export const MON569_SCREENS = {
  MARKETING: 'marketing',
  SALES: 'sales',
  SERVICE: 'service',
  CMS: 'cms',
  OPERATIONS: 'operations',
  CRM_SUITE: 'crm-suite',
  FREE_TOOLS_CRM: 'free-tools-crm',
  BUNDLE: 'bundle'
};